import { useState } from 'react';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import { CustomSelect } from '../../molecules/Dropdown';
import NumberDisplay from '../../molecules/NumberDisplay';

interface IAboutProps {
  title?: string;
  subTitle: string;
  slug: string;
  logo: string;
  priceUSD?: number;
  priceChange?: number;
  description: string;
  chain?: string;
  address?: string;
}

const About = ({
  title,
  subTitle,
  slug,
  logo,
  priceUSD,
  priceChange,
  description,
  chain,
  address,
}: IAboutProps) => {
  const [showText, setShowText] = useState(false);

  const hasPrice = priceUSD !== undefined && priceChange !== undefined;

  return (
    <div className='seo_page__about_token__content'>
      <div className='seo_page__hero_section'>
        <div className='seo_page__hero_section__head'>
          <div className='seo_page__hero_section__info'>
            <div className='seo_page__hero_section__coin'>
              <Image src={logo} size='xxxl' />
              <div className='seo_page__hero_section__coin__title'>
                <div className='box'>
                  <Text size={24} className='text--weight-500 text--grey-200'>
                    {title || subTitle}
                  </Text>
                  &nbsp;
                  <Text size={14} className='text--grey-600'>
                    ({slug})
                  </Text>
                </div>
                {hasPrice && (
                  <div className='box'>
                    <NumberDisplay
                      value={priceUSD}
                      startSymbol='$'
                      textProps={{
                        size: 18,
                        className: 'text--weight-600 text--grey-200',
                      }}
                    />
                    &nbsp;
                    {priceChange > 0 && (
                      <NumberDisplay
                        value={priceChange}
                        round={2}
                        startSymbol='+'
                        endSymbol='%'
                        textProps={{ size: 14, className: 'text--green-600' }}
                      />
                    )}
                    {priceChange < 0 && (
                      <NumberDisplay
                        value={priceChange}
                        round={2}
                        endSymbol='%'
                        textProps={{ size: 14, className: 'text--red-600' }}
                      />
                    )}
                    {priceChange === 0 && (
                      <NumberDisplay
                        value={priceChange}
                        round={2}
                        endSymbol='%'
                        textProps={{ size: 14, className: 'text--grey-400' }}
                      />
                    )}
                    &nbsp;
                    <Text size={14} className='text--grey-600'>
                      (1D)
                    </Text>
                  </div>
                )}
              </div>
            </div>
            {hasPrice && (
              <div className='seo_page__hero_section__currency'>
                <Text size={12} className='text--weight-500 text--grey-600'>
                  Currency
                </Text>
                <CustomSelect
                  onSelect={(value) => console.log(value)}
                  options={[{ value: 'usd', label: '$ (USD)' }]}
                  initial={{ value: 'usd', label: '$ (USD)' }}
                  width={160}
                  height={36}
                  gap={12}
                />
              </div>
            )}
          </div>
          {chain && address && (
            <div className='seo_page__hero_section__graph'>
              <iframe
                src={`https://charts.kattana.io/${chain}/${address}`}
                className='seo_page__hero_section__graph__iframe'
              />
            </div>
          )}
        </div>
      </div>
      {description && (
        <div className='seo_page__about_section'>
          <div
            className='seo_page__about_section__description'
            dangerouslySetInnerHTML={{
              __html: description?.split('\n\n').slice(0, 4).join('\n\n'),
            }}
          />
          {showText && (
            <div
              className='seo_page__about_section__description_second_part'
              dangerouslySetInnerHTML={{
                __html: description?.split('\n\n').slice(4).join('\n\n'),
              }}
            />
          )}
          {description?.split('\n\n').length > 4 && (
            <div
              className='seo_page__about_section__btn'
              onClick={() => setShowText(!showText)}
            >
              <Text size={12} className='text--weight-600 text--white'>
                {showText ? 'Hide' : 'Read More'}
              </Text>
              <div
                className={`${
                  showText ? 'icon-chevron-top' : 'icon-chevron-down'
                } seo_page__about_section__btn__icon`}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default About;
